export default __webpack_public_path__ + "static/media/c++.6e731ebc.svg";